<template>
  <div class="flex w-full min-w-0 items-center border border-[#cbd5e1] rounded-lg my-2 bg-white"
    @click="handleContainerClick">
    <div class="flex w-full min-w-0 flex-wrap items-center gap-1">
      <div v-for="(email, index) in emails" :key="index" class="flex items-center py-1 px-3
      text-md
        m-1 bg-[#f1f5f9] rounded-md"
           @click="editEmail(index)">
        {{ email }}
        <span class="cursor-pointer font-bold text-xs ml-1" @click.prevent="removeEmail(index)">
          <i class="pi pi-trash"></i>
        </span>
      </div>
      <input class="py-1 px-3 text-md m-1 min-w-[14rem] flex-1 shrink rounded-md box-border" type="text"
        id="email-input" ref="emailInput" :style="inputWidthStyle"
        :placeholder="$t('ExternalUsersInviteComponent.externalInvites')"
        v-model="email"
        @focus="updateInputWidth"
        @keydown.delete="deleteEmail"
        @keydown.enter="addEmail" @keydown.space="addEmail" @blur="addEmail"/>
      <!-- Off-screen mirror so offsetWidth is reliable (visibility:hidden can measure 0 in some layouts) -->
      <span ref="mirror"
        class="fixed left-[-9999px] top-0 whitespace-pre px-3 text-md pointer-events-none opacity-0"
        aria-hidden="true">
        {{ email || $t('ExternalUsersInviteComponent.externalInvites') }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    allInvolvedKssUsers: {
      type: Array,
      default: null,
    },
    involvedTaskUsers: {
      type: Array,
      default: null,
    },
    externalUsers: {
      type: Array,
      default: null,
    },
  },
  name: 'EditExternalUsersInviteComponent',
  data() {
    return {
      email: '',
      emailsData: [...(this.externalUsers || [])],
      /** Measured width from mirror; 0 = use CSS min-width only */
      inputWidth: 0,
    };
  },
  watch: {
    email() {
      this.updateInputWidth();
    },
  },
  computed: {
    emails() {
      return this.emailsData;
    },
    inputWidthStyle() {
      const minPx = 224; // 14rem — must fit placeholder before first measure
      const w = Math.max(minPx, this.inputWidth || 0);
      return { width: `${w}px`, maxWidth: '100%' };
    },
  },
  methods: {
    updateInputWidth() {
      this.$nextTick(() => {
        const mir = this.$refs.mirror;
        if (!mir) return;
        const measured = mir.offsetWidth + 16;
        this.inputWidth = Math.max(224, measured);
      });
    },
    addEmail() {
      const trimmed = (this.email || '').trim();
      if (!trimmed) {
        this.email = '';
        return;
      }
      const newEmails = trimmed.split(',')
        .map((email) => email.trim()
          .toLowerCase());
      const validEmails = newEmails.filter((email) => this.validateEmail(email));
      this.emailsData.push(...validEmails);
      if (validEmails.length < newEmails.length) {
        const invalidEmails = newEmails.filter((email) => !this.validateEmail(email));
        this.email = invalidEmails.join(', ');
      } else {
        this.email = '';
      }
      this.$emit('updateExternalUsers', this.emailsData);
    },
    removeEmail(index) {
      this.emailsData.splice(index, 1);
      this.$emit('updateExternalUsers', this.emailsData);
    },
    editEmail(index) {
      this.email = this.emailsData[index];
      this.emailsData.splice(index, 1);
      this.$nextTick(() => {
        this.$refs.emailInput.focus();
      });
    },
    handleContainerClick(event) {
      const { target } = event;
      const isInput = target === this.$refs.emailInput;
      const isPillRemove = target.classList.contains('close');
      if (!isInput && !isPillRemove) {
        this.$refs.emailInput.focus();
      }
    },
    validateEmail(email) {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(email);
    },
    deleteEmail() {
      if (this.email === '' && this.emailsData.length > 0) {
        this.emailsData.pop();
        this.$emit('updateExternalUsers', this.emailsData);
        this.email = '';
      }
    },
  },
  mounted() {
    this.updateInputWidth();
  },
};
</script>
